/**
 * SubdomainRouter Component
 * 
 * Simple wrapper that allows all routes.
 * No subdomain-based redirects.
 */

import React from 'react';

export default function SubdomainRouter({ children }) {
  // Simply render children - no redirects
  return children;
}
